import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import Tooltip from 'rc-tooltip';
import moment from 'moment';
import { avatarsSelector } from '../reducers/avatars';
import immutableCreatorSelector from '../selectors/immutableCreatorSelector';

const AvatarImage = styled.img`
  width: ${props => props.width || 50}px;
  height: ${props => props.height || 50}px;
  ${props => {
    if (props.rounded) {
      return css`
        border: 2px solid transparent;
        border-radius: 49.9% !important;
      `;
    }
    if (props.softCorners) {
      return css`
        border-radius: 2px !important;
      `;
    }
    return null;
  }};
`;

const DefaultAvatar = styled.div`
  display: inline-block;
  background-color: #d6dadc;
  overflow: hidden;
  vertical-align: middle;
  font-weight: 700;
  line-height: ${props => props.height || 50}px;
  text-align: center;
  height: ${props => props.height || 50}px;
  width: ${props => props.width || 50}px;
  height: ${props => props.height || 50}px;
  ${props => {
    if (props.rounded) {
      return css`
        border: 2px solid transparent;
        border-radius: 49.9% !important;
      `;
    }
    if (props.softCorners) {
      return css`
        border-radius: 2px !important;
      `;
    }
    return null;
  }};
`;

const MemberInitials = styled.span`
  display: block;
  font-size: 1pc;
  overflow: hidden;
  width: 100%;
`;

const AvatarSelector = immutableCreatorSelector([avatarsSelector], avatars => ({
  avatars,
}));

@connect(AvatarSelector)
export default class Avatar extends PureComponent {
  static propTypes = {
    avatars: PropTypes.instanceOf(Map),
    avatar: PropTypes.instanceOf(Map),
    user: PropTypes.instanceOf(Map).isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
    rounded: PropTypes.bool,
    softCorners: PropTypes.bool,
    className: PropTypes.string,
    enableToolTip: PropTypes.bool,
    tooltipPlacement: PropTypes.string,
  };

  getUserToolTip = () => {
    const { user } = this.props;
    if (!user || typeof user === 'undefined') {
      return '...';
    }
    let nameOutput = '';

    const firstName = user.getIn(['first_name'], null);
    const lastName = user.getIn(['last_name'], null);
    if (firstName || lastName) {
      nameOutput = `${firstName} ${lastName}`;
    }

    const displayName = user.getIn(['display_name'], null);
    if (displayName) {
      nameOutput = `${nameOutput} (${displayName})`;
    }

    return nameOutput;
  };

  getUserInitials = () => {
    const { user } = this.props;
    if (!user || typeof user === 'undefined') {
      return '...';
    }

    const firstName = user.getIn(['first_name'], null);
    const lastName = user.getIn(['last_name'], null);
    let initials = '';
    if (firstName) {
      initials = firstName.charAt(0).toUpperCase();
    }
    if (lastName) {
      initials = initials + lastName.charAt(0).toUpperCase();
    }
    if (initials.length > 0) return initials;
    // if (firstName || lastName) {
    //   return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
    // }

    const displayName = user.getIn(['display_name'], null);
    if (displayName) {
      return displayName.charAt(0).toUpperCase();
    }

    const email = user.getIn(['email'], null);

    if (email) {
      return email.charAt(0).toUpperCase();
    }

    return '...';
  };

  render() {
    const {
      avatars,
      className,
      user,
      width,
      height,
      rounded,
      softCorners,
      enableToolTip,
      tooltipPlacement,
      avatar,
      notificationOverride,
    } = this.props;

    let avatarId = false;
    const initials = this.getUserInitials();
    const defaultAvy = (
      <DefaultAvatar
        className={className}
        width={width}
        height={height}
        rounded={rounded}
        softCorners={softCorners}
      >
        <MemberInitials>{initials}</MemberInitials>
      </DefaultAvatar>
    );

    // const avatarId = (user && typeof user !== 'undefined') ? user.getIn(['avatar'], null) : false;
    if (avatar) {
      avatarId = avatar.get('id', null);
    } else if (user) {
      avatarId = user.get('avatar', null);
    }

    if (!avatarId) {
      const avatarDefault = enableToolTip ? (
        <Tooltip
          placement={tooltipPlacement || 'bottom'}
          overlay={this.getUserToolTip()}
        >
          {defaultAvy}
        </Tooltip>
      ) : (
        defaultAvy
      );

      return avatarDefault;
    }

    if (!notificationOverride) {
      const avatarMap = avatars || Map();
      if (
        (!avatar
          && (avatarMap && !avatarMap.size)) ||
          !avatarMap.getIn([avatarId, 'path']
        )
      ) {
        return defaultAvy;
      }
    }

    const userAvatarPath = avatar
      ? avatar.get('path')
      : avatars.getIn([avatarId, 'path']);

    const avatarTimestamp = moment(
      avatars.getIn([avatarId, 'updated_at'], Date.now()),
    ).unix();

    const userAvartarSrc = `//${userAvatarPath}?${avatarTimestamp}`;

    return (
      <AvatarImage
        className={className}
        src={userAvartarSrc}
        width={width}
        height={height}
        rounded={rounded}
        softCorners={softCorners}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Avatar.js